import { DEFAULT_AVATARS_GROUPING } from '@/pages/agents/constants';
import { AvatarFilter, AvatarFilterDeprecated, useAllAvatars, useAvatarsFilters } from '@/pages/avatar';
import { useFlag } from '@/services/featureFlags';
import { ImageType, PresenterUsecase, VideoType } from '@d-id/types';
import { filterV2PresenterLabel, groupAvatarsWithAlternatives, prepareBgPresentersList } from '../components/AgentAppearance/utils';
import { useAgentsPresentersSorting } from './useAgentsPresentersSorting';

interface UseAgentsPresentersProps {
    isAgentV2?: boolean;
    filter: AvatarFilter | AvatarFilterDeprecated;
}

export const useAgentsPresenters = ({ isAgentV2 = true, filter }: UseAgentsPresentersProps) => {
    const { allAvatars } = useAllAvatars(isAgentV2 ? PresenterUsecase.AgentV2 : PresenterUsecase.Agent);
    const sortPresenters = useAgentsPresentersSorting();

    const migratableAvatars: string[] = useFlag('migrated_avatars', []);
    const newAvatarsGrouping = useFlag('new_avatars_grouping', false);
    const avatarsGrouping = useFlag('avatars_grouping', DEFAULT_AVATARS_GROUPING);
    const expressiveAvatars = useFlag('expressive_avatars_for_agents', false);

    const filteredPresenters = useAvatarsFilters(allAvatars, filter);

    const bgPresenters = isAgentV2
        ? newAvatarsGrouping
            ? groupAvatarsWithAlternatives(filteredPresenters, avatarsGrouping)
            : prepareBgPresentersList(filteredPresenters, migratableAvatars)
        : filterV2PresenterLabel(filteredPresenters);

    const presentersToShow = bgPresenters.filter(p => {
        const isVideoTypeSupported = [VideoType.TALK, VideoType.CLIP, ...(expressiveAvatars ? [VideoType.EXPRESSIVE] : [])].includes(
            p.type
        );
        const isImageTypeSupported = p.presenterType ? [ImageType.Upload, ImageType.Dreams].includes(p.presenterType) : false;

        return isVideoTypeSupported && isImageTypeSupported;
    });

    return sortPresenters(presentersToShow);
};
